import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

export interface ShellStep { num: number; label: string; title: string; }

const IP_STEPS: ShellStep[] = [
  { num: 1, label: 'Step 01', title: 'Location & Buyer' },
  { num: 2, label: 'Step 02', title: 'Property & Financing' },
  { num: 3, label: 'Step 03', title: 'Currency & Growth' },
  { num: 4, label: 'Step 04', title: 'Costs & Expenses' },
];

@Component({
  selector: 'app-ip-shell',
  templateUrl: './ip-shell.component.html',
  styleUrls: ['./ip-shell.component.css']
})
export class IpShellComponent {
  @Input() activeStep: number = 1;
  @Input() steps: ShellStep[] = IP_STEPS;
  @Input() calculatorName: string = 'Investment Property Calculator';
  @Input() showStepper: boolean = true;

  constructor(private router: Router) {}

  isStepDone(n: number): boolean   { return n < this.activeStep; }
  isStepActive(n: number): boolean { return n === this.activeStep; }

  get activeStepTitle(): string {
    return this.steps[this.activeStep - 1]?.title ?? '';
  }

  exit(): void { this.router.navigate(['/']); }
}
